/* eslint-disable @typescript-eslint/no-unused-vars */
import type { LoaderFunction } from 'react-router';

import type { RouteProps } from 'src/types';

export const communityExploreGroupsLoader =
  ({ config }: RouteProps): LoaderFunction =>
  async ({ params }) => ({});
